import { render, staticRenderFns } from "./viewStaffUnavailability.vue?vue&type=template&id=8bfceeb4&"
import script from "./viewStaffUnavailability.vue?vue&type=script&lang=js&"
export * from "./viewStaffUnavailability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bfceeb4')) {
      api.createRecord('8bfceeb4', component.options)
    } else {
      api.reload('8bfceeb4', component.options)
    }
    module.hot.accept("./viewStaffUnavailability.vue?vue&type=template&id=8bfceeb4&", function () {
      api.rerender('8bfceeb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/branches/components/viewStaffUnavailability.vue"
export default component.exports